// Generated by scripts/mdi/import-questionnaires.mjs from MDI "B12 Refill 09.17.26" (5ff00db3-3fc3-41cb-8ab5-822de7456e48). Re-run instead of editing.
import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const mdiB12RefillQuestions = [
  {
    field: 'mdiB12Refill_comparedBeforeStartedVitaminB12',
    label:
      'Compared to before you started Vitamin B12 therapy, how are your primary deficiency symptoms (fatigue, numbness/tingling in hands or feet, brain fog)?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'significantly_improved_symptoms_are_well',
          value:
            'Significantly Improved: Symptoms are well-managed on my current dose.'
        },
        {
          key: 'moderately_improved_i_feel_better_but_st',
          value:
            'Moderately Improved: I feel better, but still experience occasional fatigue or mild tingling.'
        },
        {
          key: 'no_change_my_symptoms_have_not_improved',
          value: 'No Change: My symptoms have not improved.'
        },
        {
          key: 'worsened_my_symptoms_have_gotten_worse_s',
          value: 'Worsened: My symptoms have gotten worse since my last refill.'
        }
      ]
    },
    extras: { mdiQuestionId: '922f522f-c2f3-4268-8f91-2144efb1d029' }
  },
  {
    field: 'mdiB12Refill_last30DaysOftenTaken',
    label:
      'In the last 30 days, how often have you taken or injected your Vitamin B12 dose on time?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'o_100_of_the_time_never_missed_a_dose',
          value: '100% of the time (Never missed a dose)'
        },
        {
          key: 'most_of_the_time_missed_1_dose',
          value: 'Most of the time (Missed 1 dose)'
        },
        {
          key: 'frequently_missed_doses_missed_2_or_more',
          value: 'Frequently missed doses (Missed 2 or more doses)'
        }
      ]
    },
    extras: { mdiQuestionId: '418a15c9-ac3b-4951-a9c0-219b1bb4e557' }
  },
  {
    field: 'mdiB12Refill_sinceLastRefillExperiencedSymptoms',
    label:
      'Since your last refill, have you experienced any of the following symptoms? (Select all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'redness_pain_swelling_or_signs_of_infect',
          value:
            'Redness, pain, swelling, or signs of infection at the injection site'
        },
        {
          key: 'unexplained_muscle_cramps_weakness_or_ir',
          value: 'Unexplained muscle cramps, weakness, or irregular heartbeat'
        },
        {
          key: 'dizziness_severe_headaches_or_new_skin_b',
          value: 'Dizziness, severe headaches, or new skin break outs / acne'
        },
        {
          key: 'signs_of_an_allergic_reaction_hives_diff',
          value:
            'Signs of an allergic reaction (hives, difficulty breathing, facial swelling)'
        },
        {
          key: 'other_please_specify',
          value: 'Other: (please specify)',
          answer: {
            type: 'text',
            name: 'other_please_specify_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'none_of_the_above', value: 'None of the above' }
      ]
    },
    extras: { mdiQuestionId: 'eb8db896-4400-4994-8f6f-cb6841ce35ad' }
  },
  {
    field: 'mdiB12Refill_startedNewMedicationsSupplementsSince',
    label:
      'Have you started any new medications or supplements since your last prescription? (Particularly Metformin, PPIs like Omeprazole, or Chloramphenicol)',
    type: 'select',
    educationalSlide: 'If yes, please specify',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'yes_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '9006f042-58c0-4f06-9cfa-29eff8081b29' }
  },
  {
    field: 'mdiB12Refill_changesMedicalHistoryHealthProfile',
    label: 'Do you have any changes to your medical history or health profile?',
    type: 'select',
    educationalSlide:
      'This includes, (but is not limited to): • ER or Urgent care visits\n• New diagnoses',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes_please_list_out_your_changes',
          value: 'Yes: (please list out your changes)',
          answer: {
            type: 'text',
            name: 'yes_please_list_out_your_changes_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '5673cad7-317c-46f5-a5c7-1ebfa354c105' }
  },
  {
    field: 'mdiB12Refill_importantClickAttachedLinkReview',
    label:
      'IMPORTANT: please click the attached link to review the consent for your treatment plan. By typing your full legal name into the signature field you are attesting that you have read and understand this consent in its entirety.',
    type: 'info',
    subLabel:
      'Please click here to view the telehealth consent form. (https://drive.google.com/file/d/10ifKkN1B1jP5RU82mPC2L4hrFeGj-t6U/view)\n\nPlease type your full legal name below to proceed.',
    answer: {
      type: 'text',
      name: 'mdiB12Refill_importantClickAttachedLinkReview'
    },
    extras: { mdiQuestionId: 'c219e1a2-bdb1-4b9c-a31a-6d88beb64b8e' }
  },
  {
    field: 'mdiB12Refill_updateDoctor',
    label: 'Update your doctor!',
    type: 'info',
    subLabel:
      'Please let your doctor know how your treatment is going.  Feel free to ask any questions or list any concerns you may have.',
    answer: { type: 'text', name: 'mdiB12Refill_updateDoctor', rows: 4 },
    extras: { mdiQuestionId: '9fb24d5e-d245-4653-ad1d-b9fb49b77c80' }
  },
  {
    field: 'mdiB12Refill_complete',
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    type: 'info',
    isLast: true,
    answer: {},
    extras: { sendToBeluga: false, sendToMdi: false }
  }
] as const;

export type mdiB12RefillAnswerField = Partial<
  QuestionAnswerMap<typeof mdiB12RefillQuestions>
>;

export default mdiB12RefillQuestions;
